import React from 'react';

import { EWhiteLabelingClient } from '../../types/misc.enum';
import { getWhiteLabelingClient } from '../../helpers/misc.helper';

export const LogoPackage = () => {

    const whiteLabelingClient = getWhiteLabelingClient();

    if (whiteLabelingClient === EWhiteLabelingClient.RIDLEY_CONSULTING) {
        return (
            <div className='logo_package logo_package--ridley'>
                <img src="/assets/logos/ridley.svg" alt="Ridley" />
                <h6>Powered by <span>MindShield</span></h6>
            </div>
        );
    };

    return (
        <div className='logo_package logo_package--mindshield'>
            <img src="/assets/logos/mindshield.svg" alt="MindShield" />
        </div>
    );
};

export const LogoPackageHoriz = () => {

    const whiteLabelingClient = getWhiteLabelingClient();

    if (whiteLabelingClient === EWhiteLabelingClient.RIDLEY_CONSULTING) {
        return (
            <div className='logo_package__horiz logo_package__horiz--ridley'>
                <img src="/assets/logos/ridley-horiz.svg" alt="Ridley" />
            </div>
        );
    };

    return (
        <div className='logo_package__horiz logo_package__horiz--mindshield'>
            <img src="/assets/logos/mindshield-horiz.svg" alt="MindShield" />
        </div>
    );
};